/**
 * Barillet (wheel) – slider mobile et roue GSAP au scroll
 * Dépendances globales : jQuery, gsap, ScrollTrigger, Swiper
 */
(function () {
	'use strict';

	// Détection mobile/tablette (utilisée par main.js pour resize/ready)
	function isMobileOrTabletDevice() {
		var userAgent = navigator.userAgent.toLowerCase();
		var isMobileUA = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
		var isTabletUA = /ipad|android(?!.*mobile)|tablet/i.test(userAgent);
		var hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
		var hasOrientationAPI = typeof window.orientation !== 'undefined';
		var isMobileMedia = window.matchMedia('(pointer: coarse)').matches;
		return isMobileUA || isTabletUA || (hasTouch && hasOrientationAPI) || isMobileMedia;
	}
	window.isMobileOrTabletDevice = isMobileOrTabletDevice;

	function initMobileBarilletSlider() {
		var containers = document.querySelectorAll('.block-barillet_wheel-container');
		if (!containers.length || typeof Swiper === 'undefined') return;

		containers.forEach(function (barilletContainer) {
			var barilletCards = gsap.utils.toArray('.block-barillet_wheel-card', barilletContainer);
			var linkContainer = barilletContainer.querySelector('.link-container');
			if (!barilletCards.length) return;

			var sliderHTML = [
				'<div class="rowFlex">',
				'  <div class="mobile-barillet-slider swiper">',
				'    <div class="swiper-wrapper">',
				barilletCards.map(function (card, index) {
					return '      <a href="' + (card.href || '#') + '" class="block-barillet_wheel-card swiper-slide" data-index="' + index + '">' + card.innerHTML + '</a>';
				}).join(''),
				'    </div>',
				'  </div>',
				'  <div class="mobile-barillet-pagination swiper-pagination"></div>',
				linkContainer ? '  ' + linkContainer.outerHTML : '',
				'</div>'
			].join('');

			barilletContainer.innerHTML = sliderHTML;

			var sliderEl = barilletContainer.querySelector('.mobile-barillet-slider');
			var paginationEl = barilletContainer.querySelector('.mobile-barillet-pagination');
			if (!sliderEl || !paginationEl) return;

			new Swiper(sliderEl, {
				slidesPerView: 'auto',
				spaceBetween: 20,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true
				},
				pagination: {
					el: paginationEl,
					clickable: true
				},
				breakpoints: {
					768: { slidesPerView: 'auto', spaceBetween: 30 },
					1024: { slidesPerView: 'auto', spaceBetween: 40 }
				},
				speed: 600,
				touchRatio: 1,
				threshold: 5,
				on: {
					init: function () {
						this.allowSlideNext = true;
						this.allowSlidePrev = true;
						this.enable();
						this.update();
					}
				}
			});
		});
	}
	window.initMobileBarilletSlider = initMobileBarilletSlider;

	// Init au DOM ready
	jQuery(function () {
		if (!jQuery('.block-barillet_wheel').length) return;

		if (isMobileOrTabletDevice()) {
			jQuery('.block-barillet_wheel-container').addClass('isMobile');
			initMobileBarilletSlider();
			return;
		}


		function continueBarilletSetup(block, wheel, currentBarilletCards, positions, radius) {
			if (positions.length < 2) return;

			var largeurCarteAvecEspace = Math.sqrt(
				Math.pow(positions[1].x - positions[0].x, 2) +
				Math.pow(positions[1].y - positions[0].y, 2)
			);
			var perimeterUsed = largeurCarteAvecEspace * (currentBarilletCards.length - 1);
			var angleInRadians = perimeterUsed / radius;
			var baseAngle = angleInRadians * (180 / Math.PI);
			var finalAngle;
			if (currentBarilletCards.length <= 2) {
				finalAngle = baseAngle * 1.1;
			} else if (currentBarilletCards.length <= 3) {
				finalAngle = baseAngle * 1.05;
			} else if (currentBarilletCards.length <= 4) {
				finalAngle = baseAngle * 1.025;
			} else {
				finalAngle = baseAngle;
			}

			if (block._barilletScrollTrigger) {
				block._barilletScrollTrigger.kill();
				block._barilletScrollTrigger = null;
			}
			if (block._barilletPinTrigger) {
				block._barilletPinTrigger.kill();
				block._barilletPinTrigger = null;
			}

			block._barilletScrollTrigger = gsap.to(wheel, {
				rotate: -finalAngle,
				ease: 'none',
				scrollTrigger: {
					trigger: block,
					start: 'top+=400 center',
					end: 'bottom+=0',
					scrub: 1,
					invalidateOnRefresh: true,
					markers: false
				}
			});

			block._barilletPinTrigger = ScrollTrigger.create({
				trigger: block,
				start: 'center center',
				endTrigger: block,
				end: 'bottom+=0',
				pin: true,
				pinSpacing: true,
				markers: false,
				invalidateOnRefresh: true
			});

			setTimeout(function () {
				currentBarilletCards.forEach(function (item) {
					if (item && item.style) {
						item.style.opacity = '1';
						item.style.visibility = 'visible';
						item.style.display = 'block';
					}
				});
			}, 100);
		}

		function setupBarilletForBlock(block) {
			var wheel = block.querySelector('.block-barillet_wheel');
			var currentBarilletCards = gsap.utils.toArray('.block-barillet_wheel-card', block);
			if (!wheel || !currentBarilletCards.length) return;

			if (block._barilletScrollTrigger) {
				block._barilletScrollTrigger.kill();
				block._barilletScrollTrigger = null;
			}
			if (block._barilletPinTrigger) {
				block._barilletPinTrigger.kill();
				block._barilletPinTrigger = null;
			}

			gsap.set(wheel, { clearProps: 'all' });
			currentBarilletCards.forEach(function (item) {
				gsap.set(item, { clearProps: 'all' });
			});

			requestAnimationFrame(function () {
				if (!wheel.offsetWidth || !wheel.offsetHeight) {
					setTimeout(function () { setupBarilletForBlock(block); }, 100);
					return;
				}

				var radius = wheel.offsetWidth / 2;
				var center = wheel.offsetWidth / 2;
				var slice = 0.25;
				var positions = [];

				currentBarilletCards.forEach(function (item, i) {
					var angle = i * slice;
					var x = center + radius * Math.sin(angle);
					var y = center - radius * Math.cos(angle);
					positions.push({ x: x, y: y });
					gsap.set(item, {
						rotation: angle + '_rad',
						xPercent: -50,
						yPercent: -50,
						x: x,
						y: y,
						opacity: 1,
						visibility: 'visible',
						display: 'block'
					});
				});

				continueBarilletSetup(block, wheel, currentBarilletCards, positions, radius);
			});
		}

		window.setupBarillet = function () {
			if (isMobileOrTabletDevice()) return;
			var blocks = document.querySelectorAll('.block-barillet');
			blocks.forEach(setupBarilletForBlock);
		};

		window.setupBarillet();
	});
})();
